<template>
  <div class="cp-page-scroll">
    <!-- <van-pull-refresh
      v-model="pullLoading"
      @refresh="onPullRefresh"
      :head-height="headHeight"
      :success-text="successMsg"
      loading-text="正在刷新"
    >
      <van-list
        v-model="upLoading"
        :finished="upFinish"
        finished-text="-- 没有更多了 --"
        :immediate-check="false"
        :offset="20"
        @load="onUpLoad"
      >
        <slot></slot>
      </van-list>
    </van-pull-refresh> -->
    <van-list
      v-model="upLoading"
      :finished="upFinish"
      finished-text="-- 没有更多了 --"
      :immediate-check="false"
      :offset="20"
      @load="onUpLoad"
    >
      <slot></slot>
    </van-list>
  </div>
</template>

<script>
export default {
  name: 'cpPageScroll',
  props: {
    upFinish: {
      type: Boolean
    }, // 是否已加载全部数据
    isref: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      upLoading: false, // 上滑加载 - 加载动画显示
    }
  },
  methods: {
    onUpLoad () {
      setTimeout(() => { // 节流
        if (this.isref) {
          this.upLoading = true
          this.$emit('load')
        }
      }, 1000)
    },
    hideLoading () {
      this.$nextTick(() => {
        this.upLoading = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.cp-page-scroll {
  width: 100%;
  height: 100%;
  // min-height: 500px;
  background-color: transparent;
  /deep/.van-list__finished-text {
    font-size: 12px;
    line-height: 40px;
  }
}
</style>
